import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import LoginPage from './pages/LoginPage';
import AdminDashboard from './pages/AdminDashboard';
import TeacherDashboard from './pages/TeacherDashboard';
import PrivateRoute from './components/PrivateRoute';
import ChildrenManagementPage from './pages/ChildrenManagementPage';
import ManageTeachers from './components/ManageTeachers';
import ReportPage from './pages/ReportPage';
import HomePage from './pages/HomePage';
import AdminMealPage from './pages/AdminMealPage';
import AttendanceReportPage from './pages/AttendanceReportPage';

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const location = useLocation();
  const showNavbar = location.pathname !== '/';

  return (
    <>
      {showNavbar && <Navbar />}
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={<HomePage />}
        />
        <Route
          path="/admin"
          element={<PrivateRoute roles={['admin']} element={<AdminDashboard />} />}
        />
        <Route
          path="/teacher"
          element={<PrivateRoute roles={['teacher']} element={<TeacherDashboard />} />}
        />
        <Route path="/report-page" roles={['teacher']} element={<ReportPage />} />}
        <Route
          path="/group/:groupId/children"
          element={<PrivateRoute roles={['admin']} element={<ChildrenManagementPage />} />}
        />
        <Route
          path="/group/:groupId/teachers"
          element={<PrivateRoute roles={['admin']} element={<ManageTeachers />} />}
        />
        <Route
          path="/group/:groupId/children"
          element={<PrivateRoute roles={['admin']} element={<ChildrenManagementPage />} />}
        />
        <Route
          path="/meal"
          element={<PrivateRoute roles={['admin']} element={<AdminMealPage />} />}
        />
        <Route
          path="/attendance"
          element={<PrivateRoute roles={['teacher', 'admin']} element={<AttendanceReportPage />} />}
        />
      </Routes>
    </>
  );
}

export default App;
